
import './App.css';
import Header from './components/header';
import Banner from './components/banner';
import Products from './components/products';
import Checkout from './components/checkout';
import Footer from './components/footer';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

function App() {
  return (
    <Router>
    <div className="App">
      <Header />
      <Switch>
          <Route path="/checkout">
            <Checkout />
          </Route>
          <Route path="/">
              <Banner />
              <Products />
          </Route>
      </Switch>
      
      <Footer />
    </div>
    </Router>
  );
}

export default App;
